import { TYPES } from "./types";
import { eitShopService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getEITShops = (query) => async (dispatch) => {
  try {
    const result = await eitShopService.getShops(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOPS_SUCCESS,
        payload: {data},
      });

      // dispatch(setFlag(CONFIGS.FLAGS.FINISH_GET_EIT_SHOPS, true))
    } else {
      dispatch({
        type: TYPES.ACTION_GET_EIT_SHOPS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const eitShopAction = {
  getEITShops
};

// Bulk update enable_company_ids for selected shops
export const bulkUpdateEnableCompanies = (shopIds, enableCompanyIds) => async (dispatch) => {
  try {
    await eitShopService.updateEnableCompanyIds(shopIds, enableCompanyIds);
    // No specific reducer update here; caller can refetch list if needed
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: { message: error },
    });
  }
};
